<template>
  <div>
    <div id="ativador" style="display: flex">
      {{ detalhesProduto.similares }}
      {{ detalhesProduto.similares > 1 ? "similares" : "similar" }}

      <slot name="btn-ativador-dialog">
        <v-icon
          small
          class="ml-1 mt-n9"
          title="Inclusão de Itens Similares"
          @click="() => abrirSimilares()"
        >
          mdi-pencil
        </v-icon>
      </slot>
    </div>

    <v-layout justify-center>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="#042333">
            <v-btn icon dark @click="fecharSimilares()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              Produtos Similares
            </v-toolbar-title>

            <converter-embalagem class="ml-3" />
          </v-toolbar>

          <v-layout style="padding: 0px 3px 0px 3px">
            <v-flex xs12>
              <v-data-table
                :headers="CABECALHOS_COMPUTED"
                :items="itens"
                :items-per-page="10"
                :fixed-header="true"
                class="elevation-0 dialog-similar-responsivo table-full-screen"
                item-key="item_key"
                height="calc(100vh - 182px)"
                :search="search"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <h3>
                      Produtos Similares: {{ detalhesProduto.idproduto }} -
                      {{ detalhesProduto.descricao_produto }}
                    </h3>

                    <v-divider class="mx-4" inset vertical></v-divider>

                    <v-spacer></v-spacer>

                    <v-text-field
                      class="mr-5"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Pesquisar"
                      single-line
                      hide-details
                      clearable
                      style="max-width: 450px;min-width: 250px;"
                    ></v-text-field>

                    <Novosimilar
                      :detalhesProduto="{
                        ...detalhesProduto,
                        idunidade_medida: detalhesProduto.unidade_compra
                      }"
                      @atualizar-similares="abrirSimilares()"
                    />
                  </v-toolbar>
                </template>
                <template v-slot:item="props">
                  <tr>
                    <td>{{ props.item.idproduto }}</td>
                    <td>{{ props.item.cod_produto }}</td>
                    <td v-if="exibir_numero_original">
                      {{ props.item.numero_original }}
                    </td>
                    <td>{{ props.item.marca }}</td>
                    <td>{{ props.item.descricao_produto }}</td>
                    <td class="text-center">Filial {{ props.item.filial }} - {{props.item.nome_fantasia}}</td>
                    <td class="text-center">
                      {{ props.item.agregar_estoque == "S" ? "SIM" : "NÃO" }}
                    </td>
                    <td class="text-center">{{props.item.unidade_compra}}</td>
                    <td class="text-center">
                      {{Helpers.formatarValor(props.item.fator_conversao)}}
                    </td>
                    <td class="text-right">
                      {{Helpers.formatarValor(converteEmbalagemValor(props.item.consumo_medio_mensal))}}
                    </td>
                    <td class="text-right">
                      {{Helpers.formatarValor(converteEmbalagemValor(props.item.estoque))}}
                    </td>
                    <td class="text-right">
                      {{Helpers.formatarValor(props.item.compra_transito)}}
                    </td>
                    <td class="text-right">
                      {{Helpers.formatarValor(props.item.nivel_estoque)}}%
                    </td>
                    <td>
                      <EditarSimilar
                        :produto="{
                          id_grupo: detalhesProduto.id_grupo,
                          id_produto: detalhesProduto.idproduto,
                          idunidade_medida: detalhesProduto.unidade_venda
                        }"
                        :similar_edicao="{
                          id_produto: props.item.idproduto,
                          idunidade_medida: props.item.unidade_venda,
                          agredar_estoque: props.item.agregar_estoque === 'S'
                        }"
                        @update:novo-similar="abrirSimilares"
                      >
                        <template #bota-ativador="{callbackAbrirDialog}">
                          <v-btn icon @click="callbackAbrirDialog()">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                      </EditarSimilar>
                    </td>
                    <td>
                      <v-btn
                        icon
                        title="Remover Item"
                        @click="removerSimilar(props.item)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>

                <template v-slot:footer.prepend>
                  <div class="d-flex pa-0 mb-n4">
                    <p class="subtitle-2 mr-5 pa-0">Total Estoque: {{Helpers.formatarValor(converteEmbalagemValor(totalEstoqueSimilares))}}</p>
                    <p class="subtitle-2 pa-0">Total Projeção de vendas: {{Helpers.formatarValor(converteEmbalagemValor(totalConsumoMedio))}}</p>
                  </div>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { required } from "vuelidate/lib/validators"
import UtilitariosAPI from "../../../api/utilitarios"
import CompraAPI from "../../../api/compra"
import MixinCompra from "../MixinCompra";
import ConverterEmbalagem from "../Embalagem/ConverterEmbalagem";
import Novosimilar from '@/components/compra/detalhesProduto/Similares/DialogCadastro.vue';
import EditarSimilar from "@/components/produto/detalhes/Acoes/Similar/NovoSimilar.vue";

export default {
  name: "similares",
  components: {ConverterEmbalagem, Novosimilar, EditarSimilar},
  mixins: [MixinCompra],
  data () {
    return {
      dialog: false,
      dialogCreate: false,
      agruparEstoque: false,
      similarSelecionado: {},
      similarDesc: '',
      produtos: [],
      headers: [
        { text: "Cód. Interno", value: "idproduto" },
        { text: "Cód. Fornecedor", value: "idfornecedor" },
        { text: "Número Original", value: "numero_original" },
        { text: "Marca", value: "marca" },
        { text: "Descrição", value: "descricao_produto" },
        { text: "Filial", value: "filial" },
        { text: "Agregar Estoque", value: "agregar_estoque" },
        { text: "UN. Compra", value: "unidade_compra" },
        { text: "Fator de Conversão", value: "fator_conversao" },
        { text: "Projeção de vendas", value: "consumo_medio_mensal" },
        { text: "Estoque", value: "estoque" },
        { text: "Compra em trânsito", value: "compra_transito" },
        { text: "Nível estoque", value: "nivel_estoque" },
        {
          text: "",
          value: "editar",
          sortable: false,
          width: "30px",
        },
        {
          text: "",
          value: "deletar",
          sortable: false,
          width: "30px",
        },
      ],
      itens: [],
      search: '',
      exibir_numero_original: false
    }
  },
  validations: {
    similarSelecionado: {
      required,
    }
  },
  computed: {
    ...mapGetters({
      detalhesProduto: "detalhe_produto/getProduto",
      grupoCompra: "usuario/getGrupoCompras",
      fornecedorCompra: "fornecedor/getFornecedor",
    }),
    unidadesDescricao () {
      const mssg = []

      if (!this.similarSelecionado) return []

      const { unidade_venda: unVendaProduto } = this.detalhesProduto
      const { unidade_venda: unVendaSimilar } = this.similarSelecionado

      if (unVendaProduto === unVendaSimilar) {
        const { unidade_venda: unVendaProduto } = this.detalhesProduto

        mssg.push(`Unidade de venda de ambos os produtos: ${unVendaProduto}.`)
      }

      return mssg
    },
    unidadeVendaErros () {
      const erros = []

      if (!this.$v.similarSelecionado.$dirty && !this.similarSelecionado.edicao_similar) return erros

      if (!this.$v.similarSelecionado.required) {
        erros.push("Campo Obrigatório.")
        return erros
      }

      const { unidade_venda: unVendaProduto } = this.detalhesProduto
      const { unidade_venda: unVendaSimilar } = this.similarSelecionado

      !(unVendaProduto === unVendaSimilar)
      && erros.push(`Não é possivel agrupar estoque, pois a unidade de venda é diferente (${unVendaProduto} - ${unVendaSimilar}).`)

      return erros
    },
    totalEstoqueSimilares () {
      if (this.itens && this.itens.length === 0) {
        return 0;
      }
      return this.itens.reduce((acc, item) => acc + parseFloat(item.estoque), 0)
    },
    totalConsumoMedio () {
      if (this.itens && this.itens.length === 0) {
        return 0;
      }
      return this.itens.reduce((acc, item) => acc + parseFloat(item.consumo_medio_mensal), 0)
    },
    CABECALHOS_COMPUTED() {
      if (localStorage.ativar_exibicao_campo_numero_original !== 'S') {
        return this.headers.filter(item => item.value !== 'numero_original');
      }

      this.exibir_numero_original = true;
      return this.headers;
    }
  },
  methods: {
    abrirSimilares () {
      this.dialog = true
      this.getSimilaresGrupo(this.detalhesProduto)
    },
    fecharSimilares () {
      this.dialog = false
      this.$emit("fechou-dialog")
    },
    abrirDialogCreate () {
      this.similarSelecionado = {}
      this.agruparEstoque = false
      this.buscarProdutosSobDemanda()
    },
    fecharDialogCreate () {
      this.dialogCreate = false
      this.$v.$reset()
    },
    getSimilaresGrupo(produto) {
      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        pai: produto.pai || produto.idproduto,
        grupo: produto.grupo || produto.id_grupo,
        filial: produto.filial || this.filialCompra,
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getSimilares(headers, params)
          .then((response) => {
            const { token, similares, qtdeProdutos } = response.data
            localStorage.setItem("token", token)

            this.dialogSimilares = true
            this.itens = similares
            this.detalhesProduto.similares = qtdeProdutos
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false)
            this.Helpers.logout()
          })
      )
    },
    editItem(item) {
      this.dialogCreate = true
      this.similarDesc = `${item.idproduto} - ${item.descricao_produto}`
      item.edicao_similar = true;
      this.similarSelecionado = item

      if (item.agregar_estoque === "S") {
        this.agruparEstoque = true
      } else {
        this.agruparEstoque = false
      }
    },
    buscarProdutosAposDigitacao (event) {
      clearTimeout(this.interval)
      this.interval = setTimeout(() => {
        this.buscarProdutosSobDemanda(event.target.value)
      }, 700)
    },
    buscarProdutosSobDemanda (pesquisaProduto = "") {
      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        grupo: this.grupoCompra,
        pesquisaProduto
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        UtilitariosAPI.getProdutosSobDemanda(headers, params)
          .then((response) => {
            const token = response.data.token
            localStorage.setItem("token", token)

            if (response.data.produtos.length > 0) {
              this.produtos = response.data.produtos
            }
          })
          .catch(() => {
            this.Helpers.logout()
          })
      );
    },
    removerSimilar (produto) {
      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        pai: this.detalhesProduto.idproduto,
        filho: produto.idproduto,
        grupo: this.detalhesProduto.id_grupo,
        fornecedor: this.fornecedorCompra.id,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.deleteSimilares(headers, params)
          .then((response) => {
            const token = response.data.token
            localStorage.setItem("token", token)
            this.getSimilaresGrupo(this.detalhesProduto)
          })
          .catch(() => {
            this.Helpers.logout()
          })
      )
    },
    adicionarSimilar () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao()

        const params = {
          grupo: this.detalhesProduto.id_grupo,
          fornecedor: this.fornecedorCompra.id,
          pai: this.detalhesProduto.idproduto,
          filho: this.similarSelecionado.idproduto,
          agrupar_estoque: this.agruparEstoque,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          CompraAPI.addSimilares(headers, params)
            .then((response) => {
              const token = response.data.token
              localStorage.setItem("token", token)

              if (response.status == 200) {
                this.similarSelecionado = {}
                this.fecharDialogCreate()
                this.getSimilaresGrupo(this.detalhesProduto)
              }
            })
            .catch(() => {
              this.Helpers.logout()
            })
        )
      }
    }
  }
}
</script>
